<template>
	<div style="display: flex">
		
		<sf-card width="500px" height="330px" :title="getMessage_('QWCC002134')" style="margin-top: -4px; margin-left: 19px"> <!-- :title="getMessage_('QWCC002134')" -->
			<template v-if="isLoading">
				<doughnut-chart :height="280" ref="grpBar" :chartData="datacollection2" :options="optionCollection1" />
			</template>
		</sf-card>

	
		<sf-card
			width="1400px"
			height="330px"
			:title="getMessage_('QWCC002135')"                                          
			style="margin-top: -4px; margin-left: 19px"
		>     <!-- :title="this.searchParams.searchDate + getMessage_('QWCC001451') + ' ' + getMessage_('QWCC001490') + '(' + getMessage_('SWCC000572') + ')'" -->
			<template v-if="isLoading">
				<bar-chart :height="280" ref="grpLine" :chartData="datacollection1" :options="optionCollection2" />
			</template>
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/MdjMGraph/store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart,
		DoughnutChart: Chart.DoughnutChart
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.barChartLabel_, 
				datasets: this.barDataSet_
			};
		},
		datacollection2() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		},
		optionCollection1() {
			return {
				type: 'doughnut',
				responsive: true,
				maintainAspectRatio: false, 
				plugins: {
					datalabels: {
						color: '#000', 
						boxWidth: 8,
						padding: 10,
						usePointStyle: true,
						pointStyle: 'circle'
					}
				},
				legend: {
					display: true,
					position: 'bottom'
				}
			};
		},
		optionCollection2() {
			return {
				//BarChart
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					datalabels: {
						color: '#000', 
						anchor: 'end'
					}
				},
				legend: {
					display: false,
					position: 'top' 
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: this.maxbarVal
							}
						}
					]
				}
			};
		}
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
